<template>
  <div>
    <div class="c-base-transaction-details__price">
      <div class="c-base-transaction-details__icon has-text-error">
        <base-icon width="24" height="24" :name="icon" />
      </div>
      <div class="c-base-transaction-details__amount has-text-error">
        - {{ transaction.amount | currency }}
      </div>

      <p
        v-if="transaction.reference_id == 'starkbank'"
        class="c-base-transaction-details__logo--pix"
      >
        PIX
      </p>
      <p
        v-if="transaction.reference_id == 'paypal'"
        class="c-base-transaction-details__logo--paypal"
      >
        PayPal
      </p>

      <p class="c-base-transaction-details__category">
        <strong>{{ transaction.description }}</strong>
        <br />
        <small>Realizada em {{ transaction.created_at | date }}</small>
      </p>
    </div>
    <div class="c-base-transaction-details__body">
      <div class="columns is-mobile is-gapless is-multiline margin-bottom">
        <div class="column is-half">
          <p class="is-size-6">
            <strong>Valor transferido</strong>
          </p>
        </div>
        <div class="column is-half has-text-right">
          <strong class="has-text-error is-size-6">
            {{ -transaction.amount | currency }}
          </strong>
        </div>
      </div>

      <div
        v-if="transaction.type === 'debit'"
        class="columns is-gapless margin-bottom"
      >
        <div class="column">
          <p class="c-base-transaction-details__body--info">
            Referente à transferência para conta {{ getNamePartner() }}<br />
            <strong v-if="getNamePartner() === 'PayPal'">{{
              transaction.details.email
            }}</strong>
            <strong v-else>
              {{ transaction.details.bank_account.owner_full_name }}<br />
              <span v-if="transaction.details.bank_account?.bank?.name">
                {{ transaction.details.bank_account.owner_cpf }} ·
                {{ transaction.details.bank_account.bank.name }}
              </span>
              <span v-else>
                {{ transaction.details.bank_account.owner_cpf }}
              </span>
            </strong>
          </p>
        </div>
      </div>

      <div class="c-base-transaction-details__footer">
        <p class="is-size-6">
          Código da transação<br />
          <strong>
            {{ transaction.transaction_id }}
          </strong>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import BaseTransactionDetailsMixin from '@/mixins/BaseTransactionDetailsMixin'

export default {
  mixins: [BaseTransactionDetailsMixin],

  props: {
    transaction: {
      type: Object,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
  },

  methods: {
    getNamePartner() {
      if (this.transaction.reference_id === 'starkbank') {
        return 'PIX'
      } else if (this.transaction.reference_id === 'paypal') {
        return 'PayPal'
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.c-base-transaction-details {
  &__logo {
    &--pix {
      font-size: 12px;
      line-height: 1.33;
      font-weight: bold;
      color: $supportdark;
      padding: 15px 10px 4px;
    }

    &--paypal {
      font-size: 12px;
      line-height: 1.33;
      font-weight: bold;
      color: $paypal-color;
      padding: 15px 10px 4px;
    }
  }

  &__body {
    &--info {
      span {
        font-size: 14px;
        color: $gray-5;
        font-weight: normal !important;
      }
    }
  }
}
</style>
